import { gql, useQuery } from '@apollo/client';

import { PayrollAccountingTypeEnum } from '@thinknet-gmbh/platform-common';

export const GET_PAYROLL_ACCOUNTING_SETTINGS = gql`
  query getPayrollAccountingSetting($companyId: ObjectId!, $type: String!) {
    getPayrollAccountingSetting(companyId: $companyId, type: $type) {
      _id
      active
      companyId
      type
      softwareTarget
      createdBy
    }
  }
`;

export const useGetPayrollAccountingSetting = (
  companyId?: string,
  type?: PayrollAccountingTypeEnum
) => {
  const { data, loading } = useQuery(GET_PAYROLL_ACCOUNTING_SETTINGS, {
    variables: {
      companyId,
      type,
    },
    skip: !companyId || !type,
    fetchPolicy: 'no-cache',
  });

  return { setting: data?.getPayrollAccountingSetting || {}, loading };
};
